import { db } from "./firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { gamificationToFirestore, gamificationFromFirestore } from "../models/gamification";
import AuditService, { AUDIT_ACTIONS, AUDIT_MODULES } from "./audit_service";

/**
 * GamificationService
 * Centraliza as operações de banco de dados para o módulo de Gamificação.
 * Coleção: tenants/{idTenant}/gamification
 */
const GamificationService = {
    /**
     * Busca as configurações globais de gamificação do Tenant
     */
    getSettings: async (idTenant) => {
        if (!idTenant) throw new Error("ID do tenant é obrigatório.");

        const docRef = doc(db, "tenants", idTenant, "gamification", "settings");
        const snapshot = await getDoc(docRef);

        return gamificationFromFirestore(snapshot);
    },

    /**
     * Salva as configurações globais de gamificação do Tenant
     */
    saveSettings: async (gamificationData, idTenant, authUser) => {
        if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

        const docRef = doc(db, "tenants", idTenant, "gamification", "settings");
        const payload = gamificationToFirestore(gamificationData, { id: idTenant }, authUser);

        await setDoc(docRef, payload, { merge: true });

        // Auditoria
        AuditService.log({
            idTenant,
            user: authUser,
            module: AUDIT_MODULES.GAMIFICATION,
            action: AUDIT_ACTIONS.UPDATE,
            entityId: "settings",
            entityName: "Configurações de Gamificação",
            description: `Atualizou as configurações de gamificação`
        });

        return payload;
    }
};

export default GamificationService;
